module.exports = __webpack_public_path__ + "img/clue_chromebook_drive.e7ef2114.png";